/* import __COLOCATED_TEMPLATE__ from './toggle.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
let Trigger = (_class = class Trigger extends Component {
  get allowClear() {
    return this.args.allowClear ?? false;
  }
  get inputClasses() {
    let classes = [];
    if (this.args.hasErrors) {
      classes.push('is-error', 'fly-form-error');
    }
    let iconCount = 0;
    if (this.shouldShowIcon) {
      classes.push('pl-[30px]');
      iconCount += 1;
    } else {
      classes.push('pl-1.5');
    }
    let rightIconsRenderedCount = [this.shouldShowDropdownArrow, this.args.isLoading, this.hasTooltipError].filter(Boolean).length;
    iconCount += rightIconsRenderedCount;
    if (rightIconsRenderedCount === 3) {
      classes.push('pr-[66px]');
    } else if (rightIconsRenderedCount === 2) {
      classes.push('pr-[48px]');
    } else if (rightIconsRenderedCount === 1) {
      classes.push('pr-[30px]');
    } else {
      classes.push('pr-1.5');
    }

    // Changing the paddings will change the width of the input, so we need to
    // offset those changes with a negative margin.
    switch (iconCount) {
      case 1:
        classes.push('mr-[-18px]');
        break;
      case 2:
        classes.push('mr-[-36px]');
        break;
      case 3:
        classes.push('mr-[-54px]');
        break;
      case 4:
        classes.push('mr-[-72px]');
        break;
    }
    if (this.args.size === 'small') {
      classes.push('fly-form-control--sm');
    }
    return classes.join(' ');
  }
  get shouldShowIcon() {
    return this.args.showIcon && !isEmpty(this.args.icon);
  }
  get shouldShowRightIcons() {
    return this.args.isLoading || this.shouldShowDropdownArrow || this.hasTooltipError;
  }
  get hasTooltipError() {
    return this.args.hasErrors && this.args.errorType === 'tooltip';
  }
  get shouldShowDropdownArrow() {
    let {
      select
    } = this.args;
    return select.isOpen && select.resultsCount > 0;
  }
  handleInput(e) {
    if (this.args.onInput && this.args.onInput(e) === false) {
      return;
    }
    this.args.select.actions.open(e);
    this.args.onChange(e.target.value);
  }
  get showClearButton() {
    return this.allowClear && !isEmpty(this.args.value) && !this.args.select.disabled;
  }
  onKeyDown(e) {
    // If the dropdown is closed, don't propagate up and down arrow keys.
    // Otherwise it'll open again
    if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && !this.args.select.isOpen) {
      e.stopPropagation();
      return;
    }

    // Allow Enter, ArrowUp and ArrowDown to propagate to EmberPowerSelect, so
    // that dropdown suggestions can be navigated with the keyboard, and
    // confirmed with Enter.
    // Allow Tab to propagate so that keyboard users can still switch to other
    // elements.
    // Don't propagate other key presses, otherwise Power Select will try and
    // select dropdown items constantly, while we only care about the input's
    // value
    let allowPropagationKeys = ['Enter', 'ArrowUp', 'ArrowDown', 'Tab'];
    if (!allowPropagationKeys.includes(e.key)) {
      e.stopPropagation();
    }
    if (this.args.onKeydown && this.args.onKeydown(e) === false) {
      return;
    }
  }
  stopPropagation(e) {
    e.stopPropagation();
  }
  clear(e) {
    e.stopPropagation();
    this.args.onChange('');
    this.args.onClear();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopPropagation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "stopPropagation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype)), _class);
export { Trigger as default };